import React from 'react';

import './index.scss';

const ErrorText = ({ label }) => {

  return (
    <span className="ErrorText">{label}</span>
  );
};

export default ErrorText;